/**
 * Item barcode API calls.
 * TODO: All endpoints are pending backend implementation.
 * Base path: /inventory/items/{itemId}/barcodes/
 */
import client from './inventory-request';

// API: GET /inventory/items/{itemId}/barcodes/
export const getItemBarcodes = (itemId) =>
  client.get(`/inventory/items/${itemId}/barcodes/`);

// API: POST /inventory/items/{itemId}/barcodes/
export const addItemBarcode = (itemId, data) =>
  client.post(`/inventory/items/${itemId}/barcodes/`, data);

// API: PATCH /inventory/barcodes/{barcodeId}/
export const setPrimaryBarcode = (barcodeId, data) =>
  client.patch(`/inventory/barcodes/${barcodeId}/`, data);

// API: DELETE /inventory/barcodes/{barcodeId}/
export const deleteItemBarcode = (barcodeId) =>
  client.delete(`/inventory/barcodes/${barcodeId}/`);
